import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { apiError } from '../../../helpers/ErrorHelper';
import { useAuth } from '../../../context/AuthContext';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import dateFormat from "dateformat";
import { useNotificationCount } from '../../../context/NotificationCountContext';
import { createProjectMember, getProjectNonMembers } from '../../../models/ProjectModel';
import { useTheme } from '../../../context/ThemeContext';

const AddProjectMemberModal = ({showModal, setShowModal, project_unique_id, projectData, modalKey, fetchProjectMembers, limit, page}) => {

    const { theme, toggleTheme, selectBoxTheme } = useTheme();

    const { notificationCount, setNotificationCount } = useNotificationCount();

    const navigate = useNavigate();

    const { state } = useAuth(); 

    const editor = useRef(null);


    let user_data = state.user_data;
    
    const loader = document.getElementById('loading');
    
    const [loading, setLoading] = useState(false);

    const [user_id, setUserId] = useState('');
    const [member_site_visit_allowed, setMemberSiteVisitAllowed] = useState(0);


    const [errors, setErrors] = useState({user_id: ''});

    const closeModal = () =>{
        setUserId('');
        setMemberSiteVisitAllowed(0);

        setErrors({});
    
        setShowModal(false);
    }


    const [nonMembers, setNonMembers] = useState([]);
    const fetchProjectNonMembers = async () => {
        try {
          const result = await getProjectNonMembers(user_data.user_token, project_unique_id);

          const nonMemberOptions = result.non_members.map(nonMember => ({
            label: nonMember.user_first_name+' '+nonMember.user_last_name,
            value: nonMember._user_id
          }));
          setNotificationCount(localStorage.getItem('unread_notification_count'));

          setNonMembers(nonMemberOptions);
        } catch (error) {
          //console.error(error);
        }
    };

    useEffect(() => {
        if (showModal) {
            fetchProjectNonMembers();
        }
        
    }, [project_unique_id, modalKey]); 

    const addProjectMember = async() => {
        // Start the loading state
        loader.style.display = 'block';
        setLoading(true);

        try {
            // Clear previous errors
          setErrors({});

          const formData = {user_id: user_id.value ? user_id.value : '', member_site_visit_allowed};

          const response = await createProjectMember(user_data.user_token, project_unique_id, formData);

          if (response.status) {
            toast.success(response.message);

            fetchProjectMembers(limit, page);
    
            closeModal();

            setNotificationCount(localStorage.getItem('unread_notification_count'));
          }
          else{
            setErrors(response.error);
            toast.error(response.message);
          }
            
        } catch (error) {
            apiError(error);
            
            if (error.response.data.invalid_token==1) {
                navigate('/re-login');
            }
        }

        // Stop the loading state
        loader.style.display = 'none';
        setLoading(false);
    } 
    
    
    return (
        <Modal show={showModal} onHide={closeModal} size='sm'>
            <Modal.Header closeButton>
                <Modal.Title>Add Member</Modal.Title>
            </Modal.Header>
    
            <Modal.Body>
                <div className="row gy-2">

                    <div className="col-lg-12">
                        <label className="form-label">Member <span className="text-danger">*</span></label>
                        <Select
                            value={user_id}
                            onChange={setUserId}
                            options={nonMembers}
                            placeholder="- Member -"
                            isSearchable="true"
                            noOptionsMessage={() => "No member found"}
                            styles={{control: (baseStyles, state) => ({
                                ...baseStyles,
                                borderColor: state.isFocused ? 'grey' : '#ccc',
                                backgroundColor: theme == "light" ? '#fff' : '#333',
                                color: theme == "light" ? '#333' : '#fff',
                              }),
                              selectBoxTheme}}
                            theme={(selectBoxTheme) => ({
                            ...selectBoxTheme,
                            borderRadius: 0,
                            })} />

                        {errors.user_id && <p style={{ color: 'red' }}>{errors.user_id}</p>}
                    </div>

                    <div className={`col-lg-12 ${projectData.project_site_visit==0 ? 'd-none' : ''}`}>
                        <label className="form-label">Site Visit Allowed</label>

                        <div className="form-check form-check-lg form-switch">
                            <input className="form-check-input" type="checkbox" role="switch"
                            value={member_site_visit_allowed} onChange={(e) => setMemberSiteVisitAllowed(e.target.value)}   />
                        </div>
                    </div>
                </div>
            </Modal.Body>
    
            <Modal.Footer>
                <button type="button" className="btn btn-light" onClick={closeModal}>Cancel</button>
                <button type="button" className="btn btn-primary" onClick={addProjectMember}>
                {loading ? (
                        <>
                        <span className="spinner-border spinner-border-sm align-middle"></span>
                        Loading...
                        </>
                    ) : (     
                        'Submit'
                )}
                </button>
            </Modal.Footer>
        </Modal>
    );

};

export default AddProjectMemberModal;    